import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
    Input,
    OnInit,
    OnDestroy,
    ChangeDetectorRef,
} from '@angular/core';
import { FiChecklistStoreService } from '@fi-shared/checklist/fi-checklist-store.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'fi-checklist2-list-progress-cell',
    template: `
        <mat-progress-bar
            mode="determinate"
            [ngClass]="{
                orange: !isChecklistNotStarted() && !isChecklistFullFilled(),
                green: isChecklistFullFilled(),
                grey: isChecklistNotStarted(),
            }"
            [value]="getCheckpointAnsweredAmountPercentage()"
        >
        </mat-progress-bar>
        <fi-wrapper-table-span-cell [value]="getCheckpointsStatusStr()"></fi-wrapper-table-span-cell>
    `,
    styleUrls: ['./fi-checklist2-list-progress-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-list-progress-cell' },
    standalone: false,
})
export class FiChecklist2ListProgressCellComponent implements OnInit, OnDestroy {
    @Input() totalItemsCount: number;
    @Input() filledItemsCount: number;

    constructor(
        private fiChecklistStoreService: FiChecklistStoreService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.fiChecklistStoreService.checklistListDataChanged$.pipe(takeUntil(this.ngOnDestroy$)).subscribe((item) => {
            this.cdr.markForCheck();
        });
    }

    isChecklistFullFilled(): boolean {
        return this.filledItemsCount === this.totalItemsCount;
    }

    isChecklistNotStarted(): boolean {
        return !this.filledItemsCount;
    }

    getCheckpointAnsweredAmountPercentage(): number {
        return Math.round((this.filledItemsCount / this.totalItemsCount) * 100);
    }

    getCheckpointsStatusStr(): string {
        return `${this.filledItemsCount}/${this.totalItemsCount}`;
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
